import { audioFileUrl, DEFAULT_NARRATOR, NARRATORS, type Narrator, SettingKey } from "@serophin/nottldr-shared";
import { useSettings } from "@serophin/nottldr-shared/hooks";

export const PLAYBACK_SPEEDS = [0.75, 1, 1.25, 1.5, 2];

/** Where a narration is: `{AUDIO_BASE_URL}/{alias}.{id}.{narrator}.m4a`. */
export const audioUrl = (authorAlias: string, articleId: string, narrator: Narrator): string => audioFileUrl(`${authorAlias}.${articleId}.${narrator}.m4a`);

const narratorOf = (value: string | undefined): Narrator => NARRATORS.find((narrator) => narrator === value) ?? DEFAULT_NARRATOR;

const speedOf = (value: string | undefined): number => PLAYBACK_SPEEDS.find((speed) => speed === Number.parseFloat(value ?? "")) ?? 1;

export type AudioSettings = { narrator: Narrator; speed: number; cycleSpeed: () => void };

/** The narrator and the speed are settings (the browser's own when signed out); a change of speed is saved. */
export const useAudioSettings = (): AudioSettings => {
  const { settings, setSetting } = useSettings();
  const speed = speedOf(settings[SettingKey.AUDIO_SPEED]);

  const cycleSpeed = () => {
    const next = PLAYBACK_SPEEDS[(PLAYBACK_SPEEDS.indexOf(speed) + 1) % PLAYBACK_SPEEDS.length] ?? 1;
    setSetting(SettingKey.AUDIO_SPEED, String(next)).catch((error: unknown) => console.error("Failed to save the audio speed", error));
  };

  return { narrator: narratorOf(settings[SettingKey.NARRATOR]), speed, cycleSpeed };
};
